import styled from 'styled-components';

export const StaffContainer = styled.article`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  input[type=tel] {
    -webkit-text-security: disc;
  }
`;

export const StaffHeading = styled.h2`
  margin: 0;
  margin-bottom: 15px;
  padding: 0;
  
  font-size: 22px;
  line-height: 1;
  text-align: center;
`;

export const StaffDescription = styled.p`
  margin: 0;
  margin-bottom: 30px;
  padding: 0;
  
  font-size: 14px;
  line-height: 18px;
  text-align: center;
`;

export const StaffMessage = styled.p`
  margin: 0;
  margin-top: 40px;
  padding: 0;
  
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  color: ${({ status, theme }) => status === 'success' ? theme.green : theme.red };
`;

export const StaffButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  
  margin-top: 35px;
  padding: 0;
  
  @media (min-width: 768px) {
    padding: 0 15px;
  }
  
  button {
    width: 100%;
    
    font-size: 14px;
    
    &:not(:only-child) {
      width: 49%;
    }
  }
`;
